import React from 'react'
import {Hub} from 'yougile-model'
import {ArrowWithPercent} from '@components/statistics/crm-analytics/arrow-with-percent'
import {FunnelStage} from '@components/statistics/crm-analytics/crm-analytics-store'
import {getBarStyle} from '@components/statistics/crm-analytics/utils'

export const AnalyticsFunnelChart = ({
  stats,
  board
}: {
  stats: FunnelStage[]
  board: Hub
}) => (
  <div className="flex flex-row items-center justify-start">
    <div className="flex flex-col items-center mt-4 mb-8">
      <div className="h-[212px] flex border-b border-grey-l60">
        {stats.map((stat, index) => (
          <React.Fragment key={index}>
            {index > 0 && stat.transitionPercent !== undefined && (
              <div className="flex mb-[15px] items-end">
                <ArrowWithPercent percent={stat.transitionPercent} />
              </div>
            )}
            <div className="w-[112px] flex flex-col items-center justify-end">
              <div className="text-12 text-secondary mb-1">{stat.count}</div>
              <div
                className="w-[70px] min-h-[4px] rounded-t-4 mx-auto relative flex justify-center items-end"
                style={{
                  height: `${stat.percent}%`,
                  ...getBarStyle(stat.stage, board)
                }}
              />
            </div>
          </React.Fragment>
        ))}
      </div>
      <div className="flex mt-8 items-start">
        {stats.map((stat, index) => (
          <React.Fragment key={index}>
            {index > 0 && stat.transitionPercent !== undefined && (
              <div className="w-[46px]" />
            )}
            <div className="w-[112px] text-center text-12 text-secondary">
              {stat.stage}
            </div>
          </React.Fragment>
        ))}
      </div>
    </div>
  </div>
)
